<div >
    <img class="contenedorImg"[src]="ImgURL" width="350" height="350" alt="Woods Costa Rica">
</div>
